/**
 * Checks if the given path is a Teamsite page.
 * @param {string} path - The path to be checked.
 * @returns {boolean} Returns true if the path is a Teamsite page, otherwise returns false.
 */
export const isTeamsitePage = (path) => !!path.match(/\.jsp/)
